
define('jst!simple_balloon/_balloon',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="balloon-content">\n  <% if (closeOptionEnabled) { %>\n    <div class="header">\n      <div class="close-option icon-16 icon-x-black2 tooltip" title="<%= t(\'Close\') %>"></div>\n    </div>\n  <% } %>\n  <% if (_.isFunction(content)) { %>\n    <%-render(content, jstOptions)%>\n  <% } else if (_.isString(content)) {    /* backwards compatibility with the old simpleBalloon, remove when it\'s removed */ %>\n    <%-content%>\n  <% } %>\n</div>\n');
 });

